import { useMatch } from 'react-router';
import { FlightListFilterModeOptions } from '../../../../../types/dropdown-options';
import SegmentedControl from '../../../../components/inputs/SegmentedControl';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { ROUTES } from '../../../../router/routes';
import { setSetting } from '../../../../state/slices/settings-slice';

const options = FlightListFilterModeOptions.map((x) => ({ value: x.value, label: x.text }));

export function FlightListSwitchToolbarItem() {
    const isFlightList = useMatch(ROUTES.FLIGHT_LIST);
    const filterMode = useAppSelector((x) => x.settings.flightListFilterMode);
    const dispatch = useAppDispatch();

    if (!isFlightList) {
        return null;
    }

    return <SegmentedControl data={options} value={filterMode} onChange={(e) => dispatch(setSetting('flightListFilterMode', e.value))} />;
}
